module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-2-c0bfebf69d1830e71db8bee8b6cd115a.jpg";